import { render, staticRenderFns } from "./mobileFooter.vue?vue&type=template&id=aec16884&scoped=true"
import script from "./mobileFooter.vue?vue&type=script&lang=js"
export * from "./mobileFooter.vue?vue&type=script&lang=js"
import style0 from "./mobileFooter.vue?vue&type=style&index=0&id=aec16884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec16884",
  null
  
)

export default component.exports